module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/point_maedori_02@2x-a1747ec52cf81ffe814f5bd755c208d3.webp";